import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const PricingSection = styled.div`
  padding: 100px 0 160px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PricingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  

  @media screen and (max-width: 960px) {
    margin: 0 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const PricingHeading = styled.h4`
  color: #eb594c;
  font-size: 25px;
  text-align:center;
  padding: 15px;

   @media screen and (max-width: 960px) {
    padding: 25px

  }
`;

export const PricingContainer = styled.div`
  margin: 20px auto;
  display: grid;
    width:1000px;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 40px;
 @media screen and (max-width: 960px) {
  grid-template-columns: 1fr;
  width:55%;
  }

`;

export const PricingCard = styled.div`
  background: #fff;
  box-shadow: 0 6px 20px rgba(0,0,0,0.1);
  box-sizing: border-box;
 overflow: hidden;
  padding: 50% 0;
  position: relative;
height:300px;
  &:hover {
    transform: scale(1.06);
    transition: all 0.3s ease-out;

  }

  @media screen and (max-width: 960px) {
    display: flex;
    justify-content: center;
    height:300px;

    &:hover {
      transform: none;
    }
  }
`;

export const PricingContainerph = styled.div`
  display: grid;
  width:1000px;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 40px;
 @media screen and (max-width: 960px) {
  grid-template-columns: 1fr;
  width:55%;
  }

`;

export const PricingCardph = styled.div`
  background: #fff;
  box-shadow: 0 6px 20px rgba(0,0,0,0.1);
  box-sizing: border-box;
 overflow: hidden;
  position: relative;
justify-content: center;

  &:hover {
    transform: scale(1.06);
    transition: all 0.3s ease-out;

  }

  @media screen and (max-width: 960px) {
display:block
    &:hover {
      transform: none;
    }
  }
`;

export const Img = styled.img`
  display: block;
  margin-left: auto;
  margin-top:20px;
  margin-right: auto;
  height:150px;
  width: 50%;
`;

export const PricingHeadingph = styled.h4`
  color: #eb594c;
  font-size: 25px;
  text-align:center;
  padding: 15px
`;